import { takeEvery, put, call } from "redux-saga/effects";

import {
  deleteNotification,
  getAdminSentNotifications,
  sendNotification,
  sendNotificationV3,
} from "../../helpers/backend_helper";
import {
  DELETE_NOTIFICATION,
  DeleteNotificationAction,
  GET_ADMIN_SENT_NOTIFICATIONS,
  GetAdminSentNotificationsAction,
  SEND_NOTIFICATION,
  SEND_NOTIFICATION_V3,
  SendNotificationAction,
  SendNotificationV3Action,
} from "./actionTypes";
import {
  deleteNotificationError,
  deleteNotificationSuccess,
  getAdminSentNotificationsError,
  getAdminSentNotificationsSuccess,
  sendNotificationError,
  sendNotificationSuccess,
  sendNotificationV3Error,
  sendNotificationV3Success,
} from "./actions";
import { ResponseGenerator } from "../../interfaces";
import { PaginateQuery } from "../../models";

function* sendNotificationSaga({
  payload: { request },
}: SendNotificationAction) {
  try {
    yield call(sendNotification, request);
    yield put(sendNotificationSuccess());
  } catch (error) {
    yield put(sendNotificationError(error));
  }
}

function* sendNotificationV3Saga({
  payload: { request },
}: SendNotificationV3Action) {
  try {
    yield call(sendNotificationV3, request);
    yield put(sendNotificationV3Success());
  } catch (error) {
    yield put(sendNotificationV3Error(error));
  }
}

function* getAdminSentNotificationsSaga({
  payload: { request },
}: GetAdminSentNotificationsAction) {
  try {
    const response: ResponseGenerator = yield call(
      getAdminSentNotifications,
      request as PaginateQuery
    );
    yield put(getAdminSentNotificationsSuccess(response.data));
  } catch (error) {
    yield put(getAdminSentNotificationsError(error));
  }
}

function* deleteNotificationSaga({
  payload: { id },
}: DeleteNotificationAction) {
  try {
    yield call(deleteNotification, id);
    yield put(deleteNotificationSuccess());
  } catch (error) {
    yield put(deleteNotificationError(error));
  }
}

function* notificationsSaga() {
  yield takeEvery(SEND_NOTIFICATION, sendNotificationSaga);
  yield takeEvery(SEND_NOTIFICATION_V3, sendNotificationV3Saga);
  yield takeEvery(GET_ADMIN_SENT_NOTIFICATIONS, getAdminSentNotificationsSaga);
  yield takeEvery(DELETE_NOTIFICATION, deleteNotificationSaga);
}

export default notificationsSaga;
